import { UdioWrapperConfig } from '../types';
import { UdioWrapper } from '../core/wrapper';

// This creates a Udio client for browser environments
export function createBrowserUdioWrapper(
    authToken: string,
    config: UdioWrapperConfig = {}
): UdioWrapper {
    return new UdioWrapper(authToken, {
        ...config,
        fetchImplementation: window.fetch.bind(window),
    });
}